import React from "react";
import { Grid } from "@mui/material";

const EmptyContainer = (props) => {
  const {
    width = "100%",
    height = "200px",
    noDataText = "No data",
    noDataTextStyles = {},
  } = props;

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ height, width }}
    >
      <Grid item style={noDataTextStyles}>
        {noDataText}
      </Grid>
    </Grid>
  );
};

export default EmptyContainer;
